export const MIN_SEARCH_RESULTS_FOLLOW = 3;
export const SEARCH_QUERY_CHAR_LIMIT = 500;